/**
 * SplashScreen.tsx
 * لا يرسم شيئاً — يتحكّم بشاشة الافتتاح المرسومة في index.html قبل أي جافاسكربت.
 *
 * سبب هذا التقسيم: الشاشة يجب أن تُطلى مع أوّل طلاء للصفحة، وهذا مستحيل من داخل React
 * (لا يُرسم إلّا بعد تنزيل الحزمة وتنفيذها — قِيس فراغ أسود ~300-500 مللي قبل ظهوره).
 * فالعنصر في index.html، ومنطق «متى نكشف الخريطة» هنا حيث تُعرف حالة الطبقات.
 *
 * ولماذا شاشة أصلاً: عناصر الواجهة (التسميات العربية، أسماء الدول، الأشرطة) تُصيَّر فور
 * تركيب React، بينما الخريطة وطبقة الألوان تحتاجان شبكةً وفكّ صور ورفعاً إلى الـGPU —
 * فكان المستخدم يرى «القاهرة 32°» معلّقةً على سواد قبل وصول الخريطة، وهو ترتيب ظهور
 * يوحي بالعطب لا بالتحميل.
 */

import { useEffect } from 'react';

/** يطابق مدّة الانتقال في index.html. */
const FADE_MS = 280;

interface Props {
    /** جهزت الخريطة وأوّل إطار ملوّن (أو انتهى السقف الزمني). */
    ready: boolean;
}

export function SplashScreen({ ready }: Props) {
    useEffect(() => {
        if (!ready) return;
        const el = document.getElementById('boot-splash');
        if (!el) return;
        el.classList.add('bs-hiding');
        const t = window.setTimeout(() => el.remove(), FADE_MS);
        return () => window.clearTimeout(t);
    }, [ready]);

    return null;
}
